import { componentQrl, inlinedQrl, createElement, _jsxQ, _wrapSignal } from "@builder.io/qwik";
import { isEditing } from "../../../functions/is-editing.qwik.mjs";
const SelectComponent = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  return /* @__PURE__ */ createElement("select", {
    ...props.attributes,
    value: props.value,
    key: isEditing() && props.defaultValue ? props.defaultValue : "default-key",
    defaultValue: props.defaultValue,
    name: props.name,
    required: props.required
  }, (props.options || []).map((option, index) => {
    return /* @__PURE__ */ _jsxQ("option", {
      value: _wrapSignal(option, "value")
    }, null, option.name || option.value, 1, `${option.name}-${index}`);
  }));
}, "SelectComponent_component_SPKbsFLikZU"));
export {
  SelectComponent,
  SelectComponent as default
};
